export default __webpack_public_path__ + "static/media/AggregateBoard.42152126.png";